import { render, staticRenderFns } from "./BillCardBasicData.vue?vue&type=template&id=644c101c&scoped=true&"
import script from "./BillCardBasicData.vue?vue&type=script&lang=ts&"
export * from "./BillCardBasicData.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644c101c",
  null
  
)

export default component.exports